
import useProductMixin from "~/mixins/useProductMixin";
import UiLazyImg from "~/components/UI/UiLazyImg.vue";

export default {
  name: "ProductComplimentCard",
  components: { UiLazyImg },
  mixins: [useProductMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    hover: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    product: {
      handler(val) {
        this.productData = val;
      },
      immediate: true,
    },
  },
};
